// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"53e1b003","206":"f42c506f","255":"bad2f0a0","780":"c575a4de"}[chunkId] + ".chunk.js";
};